import { DocumentNode } from '@apollo/client';
import { SetOptional } from 'type-fest';

import { FormModalProps } from '@/components/modals/FormModal/FormModal';
import { TestamentaryEntityKind } from '@/types/schema';
import { PathsOf } from '@/types/subform';

import {
  EstateInclusionStatus,
  GSTStatus,
} from '../../TaxStatusSubform/TaxStatusSubform.types';
import { DefaultEstateTaxStatus } from '../shared/testamentaryEntity.types';

export const CREATE_TESTAMENTARY_ENTITY_SHORT_FORM =
  'createTestamentaryEntityShortForm' as const;

export interface CreateTestamentaryEntityShortFormFields {
  displayName: string;
  testamentaryEntityKind: TestamentaryEntityKind | '';
  createdFromEntityIds: string[];
  gstStatus: GSTStatus | '';
  estateInclusionStatus: EstateInclusionStatus | null;
  survivingSpouseStateInEstateStatus: EstateInclusionStatus | null;
  accountOwnerId: string;
}

export interface CreateTestamentaryEntityShortFormShape {
  [CREATE_TESTAMENTARY_ENTITY_SHORT_FORM]: CreateTestamentaryEntityShortFormFields;
}

export type CreateTestamentaryEntityShortFormField =
  PathsOf<CreateTestamentaryEntityShortFormShape>;

export interface NewlyCreated {
  id: string;
  displayName: string;
}

export interface CreateTestamentaryEntityModalProps
  extends SetOptional<FormModalProps, 'heading'> {
  householdId: string;
  deadClientIds: string[];
  isTwoClientHousehold: boolean;
  defaultEstateTaxStatus?: DefaultEstateTaxStatus;
  defaultName?: string;
  defaultKind?: TestamentaryEntityKind;
  onAfterCreate?: (created: NewlyCreated) => void;
  ignoredQueryDocuments?: DocumentNode[];
}
